import { ID } from "@project/shared-types";
import React, { useEffect } from "react";
import "./FixedPage.css";

interface FixedPageProps {
  id?: number | ID;
  width?: string;
  is_active: boolean;
  set_is_active: (active: boolean) => void;
  handleBeforeUnload?: (event: PopStateEvent) => void;
  className?: string;
  children?: React.ReactNode;
}

export const FixedPage: React.FC<FixedPageProps> = ({
  width,
  is_active,
  set_is_active,
  handleBeforeUnload,
  className = "",
  children,
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const activeElement = document.activeElement as HTMLElement | null;
    if (typeof window !== "undefined") {
      const isInputFocused =
        activeElement?.tagName === "INPUT" ||
        activeElement?.tagName === "TEXTAREA";

      // Добавляем проверку на input[type="file"]
      const isFileInput =
        (event.target as HTMLElement).tagName === "INPUT" &&
        (event.target as HTMLInputElement).type === "file";

      // Если это input[type="file"], не закрываем страницу
      if (isFileInput) {
        return;
      }

      // Close the fixed-page if click occurs outside of `.fixed-page-body` and no input is focused
      if (
        !isInputFocused &&
        !(event.target as HTMLElement).closest(".fixed-page-body")
      ) {
        set_is_active(false);
      }
    }
  };

  useEffect(() => {
    const originalOverflow = document.body.style.overflow;

    if (is_active) {
      document.body.style.overflow = "hidden"; // Блокируем прокрутку
    } else {
      document.body.style.overflow = originalOverflow; // Восстанавливаем прокрутку
    }

    // Очищаем стиль при размонтировании компонента
    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [is_active]);

  useEffect(() => {
    const handleBefore = (event: PopStateEvent) => {
      console.log("handleBefore");
      if (handleBeforeUnload) {
        handleBeforeUnload(event);
      } else {
        set_is_active(false);
      }
      event.preventDefault();
      event.stopPropagation();
    };

    console.log("ADDING POP STATE");

    if (!is_active) return;

    // Add extra history state for handling browser back button
    window.history.pushState(null, "", window.location.href);
    window.history.pushState(null, "", window.location.href);

    // Add popstate event listener
    window.addEventListener("popstate", handleBefore);

    return () => {
      // Clean up listener on unmount
      window.removeEventListener("popstate", handleBefore);
    };
  }, [is_active, handleBeforeUnload, set_is_active]);

  return (
    <div onClick={handleClick} className={`fixed-page fixed-page-${is_active}`}>
      <div style={{ width: width }} className={`fixed-page-body ${className}`}>
        {children}
      </div>
    </div>
  );
};
